import api from "@/api";

export default {
    namespaced: true,
    state: () => ({
        token: localStorage.getItem("token") || null,
        user: JSON.parse(localStorage.getItem("user")) || null,
    }),
    getters: {
        isAuthenticated: (state) => !!state.token,
        getUser: (state) => state.user,
    },
    mutations: {
        SET_AUTH(state, { token, user }) {
            state.token = token;
            state.user = user;
        },
        SET_USER(state, user) {
            state.user = user;
            localStorage.setItem("user", JSON.stringify(user));
        },
        CLEAR_AUTH(state) {
            state.token = null;
            state.user = null;
        },
    },
    actions: {
        async login({ commit }, { email, password }) {
            const res = await api.post("/auth/login", { email, password });
            const { token, user } = res.data;
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
            commit("SET_AUTH", { token, user });
            return user;
        },
        logout({ commit }) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            commit("CLEAR_AUTH");
        },
        async register({ commit }, { name, email, password }) {
            const res = await api.post("/auth/register", { name, email, password });
            const { token, user } = res.data;
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
            commit("SET_AUTH", { token, user });
            return user;
        },
        async forgotPassword({ }, { email }) {
            return await api.post("/auth/forgot-password", { email });
        },
        async loginWithGoogle({ commit }, { token }) {
            try {
                const res = await api.post("/auth/google", { token });
                const { token: appToken, user } = res.data;
                localStorage.setItem("token", appToken); // Ensure token is stored
                localStorage.setItem("user", JSON.stringify(user));
                commit("SET_AUTH", { token: appToken, user });
                return user;
            } catch (error) {
                console.error("Store Google Login Error:", error);
                throw error;
            }
        },
    },

};
